import "core-js/modules/web.timers.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor;

import { observable, runInAction, computed, makeObservable } from "mobx";
var intervalId;
var loopCount = 0;
var _ACCORDIONS = false; //toggle to get desired behavior

var MobileAccordionModel = (_class = /*#__PURE__*/function () {
  function MobileAccordionModel(platformUtil) {
    _classCallCheck(this, MobileAccordionModel);

    _initializerDefineProperty(this, "_model", _descriptor, this);

    _defineProperty(this, "platformUtil", void 0);

    this.platformUtil = platformUtil;
    var accordionBehavior = {
      orderAndPickupStep: {
        isOpen: true,
        isValid: true,
        isAccessed: true,
        isSubmitted: false,
        showContinue: true
      },
      orderSummaryStep: {
        isOpen: false,
        isValid: false,
        isAccessed: false,
        showContinue: true
      },
      paymentStep: {
        isOpen: false,
        isValid: false,
        isAccessed: false
      }
    };
    var singlePageBehavior = {
      orderAndPickupStep: {
        isOpen: true,
        isValid: true,
        isAccessed: true,
        isSubmitted: false,
        showContinue: false
      },
      orderSummaryStep: {
        isOpen: true,
        isValid: false,
        isAccessed: true,
        showContinue: false
      },
      paymentStep: {
        isOpen: true,
        isValid: false,
        isAccessed: true,
        showContinue: false
      }
    };
    this._model = _ACCORDIONS ? accordionBehavior : singlePageBehavior;
    makeObservable(this);
  }

  _createClass(MobileAccordionModel, [{
    key: "setFormSubmitted",
    value: function setFormSubmitted() {
      var _this = this;

      runInAction(function () {
        _this._model.orderAndPickupStep.isSubmitted = true;
        _this._model.orderSummaryStep.isSubmitted = true;
        _this._model.paymentStep.isSubmitted = true;
      });
    }
  }, {
    key: "setOrderAndPickupOpen",
    value: function setOrderAndPickupOpen(_isOpen) {
      var _this2 = this;

      runInAction(function () {
        _this2._model.orderAndPickupStep.isOpen = _isOpen;

        if (_isOpen) {
          _this2._model.orderSummaryStep.isOpen = false;
          _this2._model.paymentStep.isOpen = false;
        }
      });
    }
  }, {
    key: "setOrderSummaryOpen",
    value: function setOrderSummaryOpen(_isOpen) {
      var _this3 = this;

      runInAction(function () {
        _this3._model.orderSummaryStep.isOpen = _isOpen;

        if (_isOpen) {
          _this3._model.orderAndPickupStep.isOpen = false;
          _this3._model.paymentStep.isOpen = false;
        }
      });
    }
  }, {
    key: "goToOrderSummaryStep",
    value: function goToOrderSummaryStep() {
      var _this4 = this;

      runInAction(function () {
        _this4._model.orderAndPickupStep.isSubmitted = true;

        if (_this4._model.orderAndPickupStep.isValid) {
          _this4._model.orderAndPickupStep.isOpen = false;
          _this4._model.orderSummaryStep = {
            isOpen: true,
            isAccessed: true,
            isValid: false,
            showContinue: true
          };
          intervalId = setInterval(function () {
            if (_this4._model.orderSummaryStep.ref) {
              _this4.platformUtil.scrollToElement(_this4._model.orderSummaryStep.ref);

              loopCount = 0;
              clearInterval(intervalId);
            } else {
              if (loopCount > 5) {
                loopCount = 0;
                clearInterval(intervalId);
              } else {
                loopCount++;
              }
            }
          }, 50);
        } else {
          _this4.platformUtil.scrollToElement(_this4._model.orderAndPickupStep.ref);
        }
      });
    }
  }, {
    key: "goToPaymentTab",
    value: function goToPaymentTab() {
      var _this5 = this;

      runInAction(function () {
        _this5._model.orderSummaryStep.isOpen = false;
        _this5._model.paymentStep = {
          isOpen: true,
          isAccessed: true,
          isValid: false,
          showContinue: true
        };
        intervalId = setInterval(function () {
          if (_this5._model.paymentStep.ref) {
            // scrollAndFocusTo(this._model.paymentStep.ref);
            _this5.platformUtil.scrollToElement(_this5._model.paymentStep.ref);

            loopCount = 0;
            clearInterval(intervalId);
          } else {
            if (loopCount > 5) {
              loopCount = 0;
              clearInterval(intervalId);
            } else {
              loopCount++;
            }
          }
        }, 50);
      });
    }
  }, {
    key: "model",
    get: function get() {
      return this._model;
    }
  }]);

  return MobileAccordionModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_model", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "model", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "model"), _class.prototype)), _class);
export { MobileAccordionModel as default };